import React from "react";
import { get, filter, map, sortBy, includes } from "lodash";

import Grid from "@material-ui/core/Grid";

import FormSection from "../../Common/FormSection";

import { getAttributeValue } from "../../../utils/profile";

const GenericForm = (props) => {
  const {
    section,
    data,
    lov,
    handleChange,
    validForm,
    language,
    profileAttributes,
  } = props;

  const isValid = (id) => {
    if (validForm && validForm[id]) {
      return true;
    }
    return false;
  };

  const mainAttributes = sortBy(
    filter(
      profileAttributes,
      (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
    ),
    (attr) => get(attr, ["app_display_seq_numb"])
  );
  const secondaryAttributes = sortBy(
    filter(
      profileAttributes,
      (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
    ),
    (attr) => get(attr, ["app_display_seq_numb"])
  );

  const attributes = section === "main" ? mainAttributes : secondaryAttributes;
  
  return (
    <Grid container style={{ marginTop: "-14px" }}>
      {map(attributes, (attr) => {
        return attr.id===135?null:<Grid
          item
          key={attr.id}
          xs={3}
          style={{
            paddingBottom: "0px",
            padding: "10px 24px 0px 24px",
            minWidth: "248px",
            maxWidth: "308px",
          }}
        >
          <Grid container direction="column">
            <FormSection
              formValue={[getAttributeValue(data, attr.id)]}
              setFormValue={handleChange}
              attribute={attr}
              id={attr.id}
              type={
                includes(["radiobutton", "lov(picker)"], attr.data_type)
                  ? "select"
                  : attr.data_type === "boolean"
                  ? "boolean"
                  : "input"
              }
              options={{
                redBorder: attr.required && !isValid(attr.id),
                comboBox: attr.id === 89,
                options: includes(
                  ["radiobutton", "lov(picker)"],
                  attr.data_type
                )
                  ? map(
                      sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                      (t) => ({
                        id: t.id,
                        name: t[`name_${language}`],
                      })
                    )
                  : null,
              }}
            />
          </Grid>
        </Grid>
      })}
    </Grid>
  );
};

export default GenericForm;
